import formatPdfFileName from './formatPdfFileName';
import uploadFileWithFormData from './uploadFileWithFormData';

type PdfFolderPath = 'pdfs/reports/' | 'pdfs/report_cards/' | 'pdfs/summaries/';
export default function uploadPdfBlobWithOpts (
  pdfBlob: Blob,
  opts: {
    organizationName: string;
    radius: string;
    zip: string;
    // graphUserId: string;
    container?: string;
    folderPath?: PdfFolderPath;
  }
) {
  const formData =  new FormData();
  const fileName = formatPdfFileName(
    opts.organizationName, 
    opts.radius,
    opts.zip
  );
  const file = new File([pdfBlob], fileName);
  formData.append('file', file);
  formData.append('containerName', opts.container);
  formData.append('folderPath', opts.folderPath);
  return uploadFileWithFormData(formData, 'application/pdf');
}
